angular.module('app').directive('uiButterbar', [
    '$rootScope',
    '$anchorScroll',
    function($rootScope, $anchorScroll) {
        return {
            restrict: 'AC',
            template: '<span class="bar"></span>',
            link: function(scope, el, attrs) {
                el.addClass('butterbar hide');

                var isInStateChange = false;
                var inLoadingDataCount = 0;

                scope.$on('$stateChangeStart', function(event) {
                    $anchorScroll();
                    el.removeClass('hide').addClass('active');

                    isInStateChange = true;
                });

                scope.$on('$stateChangeSuccess', function(
                    event,
                    toState,
                    toParams,
                    fromState
                ) {
                    event.targetScope.$watch('$viewContentLoaded', function() {
                        if (!inLoadingDataCount) {
                            el.addClass('hide').removeClass('active');
                        }

                        isInStateChange = false;
                    });
                });

                scope.$on('$resetButterbar', function(event) {
                    isInStateChange = false;
                    inLoadingDataCount = 0;
                    el.addClass('hide').removeClass('active');
                });

                scope.$on('$loadingDataStart', function(event) {
                    $anchorScroll();
                    el.removeClass('hide').addClass('active');

                    inLoadingDataCount++;
                });

                scope.$on('$loadingDataSuccess', function(event) {
                    if (inLoadingDataCount > 0) {
                        inLoadingDataCount--;
                    }
                    if (!isInStateChange && inLoadingDataCount === 0) {
                        el.addClass('hide').removeClass('active');
                    }
                });
            },
        };
    },
]);
